import { useMutation } from '@tanstack/react-query';

import {
    callSetPlayerBudget,
    type UpdateCompetitionPlayerBudgetParams,
} from '@app/client/resources/admin/fantasy/players';
import { COMPETITIONS_LEADERBOARD_CACHE } from '@app/client/resources/competitions';
import { WISHLIST_SUMMARY_CACHE } from '@app/client/resources/fantasy';

import { useQueryInvalidation } from '../../../reactQuery';

export function useUpdatePlayerCompetitionBudget() {
    const caches = [...WISHLIST_SUMMARY_CACHE, ...COMPETITIONS_LEADERBOARD_CACHE];
    const invalidateQueries = useQueryInvalidation(caches);
    const onError = (e) => alert(e);
    return useMutation({
        mutationFn: (params: Omit<UpdateCompetitionPlayerBudgetParams, 'value'>) => callSetPlayerBudget({ ...params }),
        onSuccess: () => {
            invalidateQueries();
            alert(`Budget successfully updated for player.`);
        },
        onError,
    });
}
